import { alpha } from '@mui/material';
import { theme } from '../../styles/theme';

// Tabs as transparent pills: grey labels, primary-tinted selected tab
export const pillTabsSx = {
	px: 0,
	background: 'none',

	'.MuiTab-root': {
		gap: .75,
		p: 1,
		color: theme.palette.grey[500],
		fontWeight: 600,
		border: `1px solid ${alpha(theme.palette.grey[300], 0)}`,
		transition: 'all .2s ease-in-out',

		'.MuiTab-iconWrapper': { m: 0, width: theme.spacing(2), height: theme.spacing(2) },

		'&:hover': {
			color: theme.palette.grey[900],
			background: theme.palette.grey[200],
		},
	},

	'.MuiTab-root.Mui-selected': {
		color: theme.palette.primary.main,
		background: alpha(theme.palette.primary.main, .1),
		border: `1px solid ${alpha(theme.palette.primary.main, .2)}`,
		boxShadow: 'none',
	},
};
